"use client";
import DOMPurify from "dompurify";
import React, { useEffect, useState } from "react";
import styles from "./Markdown.module.scss";

type Props<C extends React.ElementType> = {
	component?: C;
	className?: string;
	content?: string;
	renderEmpty?: boolean;
} & React.ComponentPropsWithoutRef<C>;

const Markdown = <C extends React.ElementType = "div">({
	component,
	className = "",
	content,
	renderEmpty = false,
	...rest
}: Props<C>) => {
	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	// remove empty lines that can get left
	if (content === "<p><br></p>") {
		content = "";
	}

	content =
		typeof content === "string" ? content.replace(/<p>&nbsp;<\/p>/g, "") : "";

	if (!renderEmpty && !content) {
		return null;
	}

	const Component = component || "div";
	const sanitizedContent =
		typeof window === "undefined" || typeof DOMPurify?.sanitize !== "function"
			? content || ""
			: DOMPurify.sanitize(content || "");

	return (
		<Component
			{...rest}
			className={`${className} ${!content ? "no-content" : ""} ${
				styles.markdown
			}`}
			// biome-ignore lint: required for component to work
			dangerouslySetInnerHTML={{
				__html: isClient ? DOMPurify.sanitize(content || "") : content || "",
			}}
		/>
	);
};

export default Markdown;
